const { merge } = require('webpack-merge');
const {getOptions, setOptions} = require('./utils');
const parse = require('./parse');
const stringify = require('./stringify');
const types = require('./types');

module.exports = {
  parse,
  stringify,
  types: types,
  getOptions,
  setOptions
};
